export * from 'server/models/OverrideServiceVessel';


// WEBPACK FOOTER //
// ./data/models/OverrideServiceVessel.ts